<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="moul flex items-center mb-8 text-2xl">
        <Link class="flex items-center text-indigo-400 hover:text-indigo-600" href="/users"><UsersIcon class="mr-2 w-8 h-8" /> បុគ្គលិក</Link>
        <span class="text-indigo-400 font-medium"><ChevronRightIcon class="w-5 h-5" /></span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> បុគ្គលិកនេះត្រូវបានលុបចោលហើយ! </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="គោត្តនាម *" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="នាមខ្លួន *" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="លេខទូរសព្ទ" />
          <!-- <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="អ៊ីមែល *" /> -->
          <select-input v-if="auth.user.owner" v-model="form.owner" :error="form.errors.owner" class="pb-8 pr-6 w-full lg:w-1/2" label="តួនាទី">
            <option :value="true">អ្នកគ្រប់គ្រង</option>
            <option :value="false">មន្ត្រីឥណទាន</option>
          </select-input>
          <div class="w-full mb-4">
            <hr />
          </div>
          <text-input
            v-if="isSelf"
            v-model="form.old_password"
            :error="form.errors.old_password"
            class="pb-8 pr-6 w-full lg:w-1/2"
            type="password"
            autocomplete="current-password"
            label="លេខសម្ងាត់បច្ចុប្បន្ន"
          />
          <text-input
            v-model="form.password"
            :error="form.errors.password"
            class="pb-8 pr-6 w-full lg:w-1/2"
            type="password"
            autocomplete="new-password"
            label="លេខសម្ងាត់ថ្មី"
          />
          <!-- <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="រូបភាព" /> -->
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">លុបចេញ</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">រក្សាទុក</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import { UsersIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    UsersIcon,
    ChevronRightIcon,
  },
  layout: Layout,
  props: {
    auth: Object,
    user: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        phone: this.user.phone,
        email: this.user.email,
        old_password: '',
        password: '',
        owner: this.user.owner,
        photo: null,
      }),
    }
  },
  computed: {
    isSelf() {
      return this.auth.user.id === this.user.id
    },
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('old_password', 'password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
